import React from "react";
import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { CircularProgress } from "@mui/material";
import { router } from "./Router";
import { creativeTheme } from "./libs/theme/theme";
import { LoadingFullPage } from "./pages";
import { setupAllInterceptors } from "./libs/apis/axios-interceptor";

export const App = () => {
  setupAllInterceptors();

  return (
    <ThemeProvider theme={creativeTheme}>
      <React.Suspense fallback={<LoadingFullPage />}>
        <RouterProvider
          router={router}
          fallbackElement={<CircularProgress />}
        />
      </React.Suspense>
    </ThemeProvider>
  );
};
